<template>
  <v-dialog v-model="$store.state.loginDialog" max-width="290">
    <v-card v-if="!emailSent">
      <v-img :src="require('@/assets/images/connect_illus.svg')" />
      <div class="ma-5" style="margin-top:0 !important; margin-bottom:0 !important;">
        <h2 class="styloText" style="text-align:center; margin:0; padding:0;">Connexion</h2>
        <v-tabs v-model="connectMode" :centered="true" :grow="true">
          <v-tab value="google">Google</v-tab>
          <v-tab value="email">Email</v-tab>
        </v-tabs>
        <div style="text-align:center; " v-if="connectMode == 0">
          <v-switch v-model="cgu" label="J'accepte les conditions générales d'utilisation Bige"></v-switch>

          <v-btn color="primary" @click="googleSignin" :disabled="!cgu" large>Sign in with google</v-btn>
          <br />
        </div>
        <div style="text-align:center; " v-if="connectMode == 1">
          <v-text-field
            label="Entre ton email"
            v-model="email"
            :rules="emailRules"
            hide-details="auto"
          ></v-text-field>
          <br />
          <v-switch v-model="cgu" label="J'accepte les conditions générales d'utilisation Bige"></v-switch>
          <v-btn
            color="primary"
            @click="emailSignin"
            :disabled="!cgu || !emailRules"
            large
          >Email Signin</v-btn>
        </div>
      </div>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary darken-1" text to="/cgu" @click="$store.state.loginDialog = false">CGU</v-btn>
        <v-btn color="primary darken-1" text @click="$store.state.loginDialog = false">Annuler</v-btn>
      </v-card-actions>
    </v-card>
    <v-card v-if="emailSent">
      <v-img :src="require('@/assets/images/icons/bige-icon-newsletter.svg')" />
      <div class="ma-5" style="margin-top:0 !important; margin-bottom:0 !important;">
        <h2 class="styloText" style="text-align:center; margin:0; padding:0;">Email envoyé</h2>
        <p>Un email vient de vous être envoyé à l'adresse {{email}}, cliquez sur le lien contenu dans cet email pour finaliser la connexion.</p>
      </div>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary darken-1" text @click="$store.state.loginDialog = false">OK</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
// const fb = require("@/config/firebaseConfig");
import firebase from "firebase/app";
import "firebase/auth";
export default {
  computed: {},
  data() {
    return {
      cgu: true,
      connectMode: "google",
      email: "",
      emailRules: [
        (v) => !!v || "E-mail requis",
        (v) => /.+@.+/.test(v) || "E-mail must be valid",
      ],
      emailSent: false,
    };
  },
  methods: {
    emailSignin() {
      var actionCodeSettings = {
        url: window.location.origin,
        handleCodeInApp: true,
      };
      var _self = this;
      firebase
        .auth()
        .sendSignInLinkToEmail(_self.email.trim(), actionCodeSettings)
        .then(function () {
          // The link was successfully sent. Inform the user.
          // Save the email locally so you don't need to ask the user for it again
          // if they open the link on the same device.
          window.localStorage.setItem("emailForSignIn", _self.email.trim());
          _self.emailSent = true;
        })
        .catch(function (error) {
          console.log("error signinemaillink  => ", error);
          // Some error occurred, you can inspect the code: error.code
        });
    },
    googleSignin() {
      var provider = new firebase.auth.GoogleAuthProvider();
      // firebase.auth().languageCode = "fr";
      // provider.addScope("profile");
      // provider.addScope("email");
      // provider.addScope("https://www.googleapis.com/auth/contacts.readonly"); // sample google signin scopes usecase
      firebase
        .auth()
        .signInWithPopup(provider)
        .then(
          // eslint-disable-next-line no-unused-vars
          function (result) {
            // This gives you a Google Access Token. You can use it to access the Google API.
            // var token = result.credential.accessToken;
            // The signed-in user info.
            // var user = result.user;
          }.bind(this)
        )
        .catch(
          // eslint-disable-next-line no-unused-vars
          function (error) {
            console.log("login error ", error);
            // Handle Errors here.
            /* var errorCode = error.code;
            var errorMessage = error.message;
            // The email of the user's account used.
            var email = error.email;
            // The firebase.auth.AuthCredential type that was used.
            var credential = error.credential; */
            // ...
            // Handle Errors here.
            var errorCode = error.code;
            var errorMessage = error.message;
            // The email of the user's account used.
            var email = error.email;
            // The firebase.auth.AuthCredential type that was used.
            var credential = error.credential;
            console.log(
              "errorCode  : ",
              errorCode,
              " errorMessage : ",
              errorMessage,
              " email : ",
              email,
              " credential : ",
              credential
            );
          }.bind(this)
        );
    },
    smsSignin() {
      var phoneNumber = "+33 768651457";
      var appVerifier = window.recaptchaVerifier;

      firebase
        .auth()
        .signInWithPhoneNumber(phoneNumber, appVerifier)
        .then(function (confirmationResult) {
          // SMS sent. Prompt user to type the code from the message, then sign the
          // user in with confirmationResult.confirm(code).
          window.confirmationResult = confirmationResult;
        })
        // eslint-disable-next-line no-unused-vars
        .catch(function (error) {
          // Error; SMS not sent
          // ...
        });
    },
  },
};
</script>